<template>
    <div class="max-h-full min-h-full flex flex-col w-full overflow-hidden" v-allow:auth="'form.read'">
        <sub-header backButton :handleClick="checkPermission('form.edit') && showSectionModal" :showBtn="checkPermission('form.edit') && checkPermission('form.read')" buttonText="Add Section" :backRedirectionUrl="`/form-admin/`" :customCrumbLists="customCrumbs" />
        <div class="flex flex-1 flex-col flex-grow max-h-full max-w-full overflow-y-auto scroll-bar">
            <span v-if="isLoading" class="flex h-44 min-w-full bg-card-bg items-center flex-col justify-center rounded-md">
                <loader class="my-5" height="32px" width="32px" :loading="isLoading" />
                <span> Loading... </span>
            </span>
            <div v-else class="w-full flex gap-4 max-h-full overflow-y-auto">
                <div :class="showSidePanel ? 'w-8/12' : 'w-full'" class="max-h-full flex flex-col gap-3 min-full overflow-y-auto scroll-bar pr-2">
                    <!-- Check Details -->
                    <checkDetails :checkData="checkData" @handleSaveCheck="handleSaveCheck" @handleDeleteCheck="handleDeleteCheck" :handleReadAccessMethod="handleReadAccessMethod"/>
                    <!-- End Check Details -->

                    <!-- Section list -->
                    <sectionLists
                        :isUserPermission="isUserPermission"
                        :sections-list-options="{
                            showCollectDataTag: true
                        }"
                        :sectionList="sectionList"
                        :checkData="checkData"
                        @drag="drag"
                        @sectionReorder="hanldeSectionReorder"
                        @AddNewBlock="addBlock"
                        :showSidePanel="showSidePanel"
                        @fieldNameClick="fieldNameClick($event)"
                        @handleDeleteField="handleDeleteField($event.field, $event.section)"
                        @updateFieldLabel="updateFieldLabel($event.section, $event.field, $event.silent)"
                        @handleRemoveSection="handleRemoveSection"
                        @handleFieldMove="handleFieldChange($event)"
                        @handleAddFieldChange="handleAddFieldChange($event)"
                        @handleShowPanel="handleShowPanel($event.field, $event.section)"
                        :activeFieldPanel="activeFieldPanel"
                        @handleRemoveBlock="handleRemoveBlock($event.section, $event.element)"
                        @handleUpdateBlock="handleUpdateBlock($event.section, $event.element)"
                        @saveBlockFields="saveBlockFields($event.section, $event.element)"
                        @showfieldAddModal="showFieldAddModal($event.section, $event.element)"
                        @showBlockModal="showBlockModal($event)"
                        @updateSectionLabel="updateSectionLabel($event)"
                        @PermissionChange="PermissionChange($event)"
                        :allReportsRoles="allReportsRoles"
                        @showFieldSettingsModal="showFieldSettingsModal($event.field, $event.section)"
                        @showGapValidationModal="showGapValidationModal($event.field, $event.section)"
                        :updateSectionFieldsMethod="updateSectionFields"
                        :updateBlockFieldsMethod="handleUpdateBlock"
                        @changeCaseCreation="changeCaseCreation"
                        @changeblockVisibile="changeblockVisibile"
                        :updateFieldAttributesMethod="updateFieldLabel"
                        :isAdditionalForm = "true"
                        :changeCaseCreationMethod="changeCaseCreation"
                        :changeMethod="changeblockVisibile"
                        @changeCollectDataFrom="changeCollectDataFrom"
                    />
                    <!-- end section list -->
                </div>

                <!-- Side Panel Section -->
                <div v-if="showSidePanel && activeFieldPanel.field" class="bg-card-bg  min-h-full max-h-full overflow-y-auto shadow-md rounded-lg scroll-bar" :class="showSidePanel && 'w-4/12'">
                    <expanded-panel :allReportsRoles="allReportsRoles" :activeFieldPanel="activeFieldPanel" :dependentsFields="dependentsFields" :checkData="checkData" :loadingState="loadingState" @handleClosePanel="handleClosePanel" @PermissionChange="PermissionChange($event)" @updateDependentsFieldLabel="updateDependentsFieldLabel($event)" @updateFieldLabel="updateFieldLabel($event.section, $event.field)" @handleSelectAllFieldPermission="handleSelectAllFieldPermission" />
                </div>

                <!-- End Side Panel Section -->
            </div>
        </div>

        <add-section-modal ref="show-section-modal" @addNewSection="addNewSection" />

        <!-- delete popup confirm -->

        <modal-confirm title="Are you sure?" message="Please confirm you're about to delete the field." ref="confirm-popup"> </modal-confirm>

        <!-- Field add Modal -->
        <!-- <add-field-modal ref="section-addfield-modal" :fieldLists="fieldLists" :fieldToAdd="fieldToAdd" :isGapValidationField="isGapValidationField" @handleGapValidationPayload="handleGapValidationPayload($event)" :loadingState="loadingState" @PermissionChange="PermissionChange($event)" @handleSelectAllPermission="handleSelectAllPermission($event)" @addFieldToSection="addFieldToSection" /> -->
        <AddBlockFieldModal
          :open="showBlockAddModal"
          :listType="listType"
          :lists="filteredFieldList"
          :loadingLists="loadingState.addFields"
          :filters="addFieldFilters"
          isAdditionalForm
          @handleAddFieldToBlock="onAddField($event)"
          @handleFilterResult="onChangeFilterResult($event)"
          @close="closeFieldAddModal"
        />

        <AddBlockModal
          ref="block-modal"
          :lists="filterBlockLists"
          :loadingLists="loadingLists"
          :filters="addFieldFilters"
          isAdditionalForm
          @handleFilterResult="onChangehandleFilterResult($event)"
          @handleCollectData="handleCollectData"
          @AddNewBlock="addBlock($event)"
        />

        <FieldSettingsModal ref="fieldSettingsModal" :data="activeFieldSettings" :getDependentsMethod="getDependents" :getOptionsMethod="getOptions" :updateDependentFieldMethod="updateDependentsFieldLabel" :changeCaseCreationMethod="changeCaseCreation" :changeblockVisibileMethod="changeblockVisibile" :roles="allReportsRoles" @closed="showFieldSettingsModal(null)" />
        
        <ModalContent name="gap-time-line-modal" ref="modal" width="640px" :showFooter="false" @closed="closeGapTimeLineModal">
            <template #title>Gap Timeline Attributes </template>
            <template #content>
                <GapTimeLineForBlock 
                    :loadingStates="loadingStates" 
                    :dateTypeFields="dateTypeFields" 
                    :currentBlockField="currentAddedBlockGapField"
                    @updateActiveTab="updateActiveTab($event)"
                    @handleResetGapTimelineFields="handleResetGapTimelineFields" 
                    @updateOption="updateOption($event)" 
                    @updateLabel = "updateLabel($event)"
                    @updateTillPreset="updateTillPreset($event)" 
                    @handleUpdateBlockFieldGapTimeLine="handleUpdateBlockFieldGapTimeLine" />
            </template>
        </ModalContent>

        <GapValidationModal ref="gapValidationModal" 
            :data="activeGapValidation" 
            @closed="showGapValidationModal(null)" 
            :updateFieldMethod="updateFieldLabel"
            @updateActiveTab="updateActiveTab($event)"
            @updateOption="updateOption($event)"
            @updateLabel = "updateLabel($event)"
            @updateTillPreset="updateTillPreset($event)" 
            @handleUpdateBlockFieldGapTimeLine="handleUpdateBlockFieldGapTimeLine" />
            
        <loader-full v-if="isGlobalLoader.status" :loadingText="isGlobalLoader.message" />
    </div>
</template>

//It's a quick way, need to remove this later
<script>
import SubHeader from "@/components/SubHeader";
// import Input from "@/components/input";
import axios from "@/axios";
import loader from "@shared/loader";
import LoaderFull from "@/components/loader-full";
import ModalContent from "@shared/modal-content";
// import VueMultiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
const modalConfirm = () => import("@/components/modal-confirm");
// import Button from "@/components/button";
// import Checkbox from "@/components/checkbox";
import { uuid } from "vue-uuid";
// Static use Only Remove after Proper API
// import checkGapValidationInput from "../checkGapValidationInput";
import { mapState, mapActions } from 'vuex';
import { formatSections, fetchAllRoles, fetchReportVisibility } from "@/modules/field-editor/services.js";

import checkDetails from "./components/formDetails.vue";
import sectionLists from "@/pages/check-admin/check-dragable-section/components/sectionLists.vue";
import { cloneDeep } from "lodash";
const addSectionModal = () => import("@/pages/check-admin/check-dragable-section/components/check-modals/add-section-modal");
const expandedPanel = () => import("@/pages/check-admin/check-dragable-section/components/expanded-panel");
const AddBlockModal = () => import("@/pages/check-admin/check-dragable-section/components/check-modals/add-block-modal.vue");
// const addFieldModal = () => import("@/pages/check-admin/check-dragable-section/components/check-modals/add-field-modal.vue");
import FieldSettingsModal from "@shared/components/modals/field-settings-modal.vue";
import GapValidationModal from "@shared/components/modals/gap-validation-modal.vue";
const GapTimeLineForBlock = () => import("@shared/gapTimeLine");
const AddBlockFieldModal = () => import("../../../pages/block-admin/components/addBlockAndFieldModal.vue");
import { checkPermission } from "@shared/utils/functions"

import { COLLECT_DATA_FROM_LIST } from "@/modules/form-admin/pages/constants.js";
import VueCookies from "vue-cookies";
// end
export default {
    name: "two-list-headerslots",
    display: "Transitions",
    order: 16,
    components: {
        SubHeader,
        // VueMultiselect,
        // "neo-input": Input,
        loader,
        ModalContent,
        modalConfirm,
        // Button,
        // Checkbox,
        // checkGapValidationInput,
        checkDetails,
        sectionLists,
        addSectionModal,
        expandedPanel,
        AddBlockModal,
        // addFieldModal,
        FieldSettingsModal,
        GapValidationModal,
        GapTimeLineForBlock,
        AddBlockFieldModal,
        LoaderFull,
    },
    data() {
        return {
            gapValidationPayload: {},
            isLoading: true,
            drag: false,
            sectionList: [],
            sectionName: "",
            showSidePanel: false,
            activeFieldPanel: null,
            checkData: null,
            fieldLists: [],
            fieldToAdd: {
                section: null,
                block: null,
                field: null,
                permisions: null,
                report_visibility: null,
            },
            activeSection: null,
            blockName: "",
            tenantId: null,
            oldSectionName: "",
            oldFieldName: "",
            allRoles: [],
            fetchingRoles: false,
            allReportsRoles: [],
            selected_report_option: "",
            loadingState: {
                addFields: false,
                getDependent: false,
            },
            dependentsFields: [],
            activeFieldSettings: {
                field: null,
                section: null,
            },
            loadingLists: false,
            blockLists: [],
            blockSearchValue: "",
            activeGapValidation: {
                field: null,
                section: null,
            },
            customCrumbs: [],
            showBlockAddModal: false,
            listType: {
                type: "field",
                listModalTitle: "Add Field ",
                permissionModalTitle: "Field Settings",
            },
            filterFiledValue: "",
            loadingStates: {
                dateType: false,
            },
            currentAddedBlock: null,
            currentAddedBlockGapField: null,
            dateTypeFields: [],
            isGlobalLoader: {
                status: false,
                message: ''
            },
            collect_data_from: null,
            fieldTypeFilter: [],
        };
    },
    async mounted() {
        this.isLoading = true;
        this.tenantId = this.$store.getters.getTenantId;
        this.collect_data_from = COLLECT_DATA_FROM_LIST?.[0]?.id
        // this.fieldLists = await this.fetchFieldsList();
        await this.getCheckDetails();
        await this.fetchAllAvailableRoles();
        await this.fetchAvailableReportVisibility();
    },
    computed: {
        ...mapState({
            entityTypeOptions: 'entityTypeList',
            isDirty: state => state.formsAdmin.isDirty            
        }),
        isBlockGapValidation() {
            return this.currentAddedBlock.use_in_gap_validation || this.currentAddedBlock.field.use_in_gap_validation || false;
        },
        isGapValidationField() {
            if (this.fieldToAdd.field?.meta) {
                const json_meta = JSON.parse(this.fieldToAdd.field.meta);
                return json_meta.use_in_gap_validation === true;
            }
            return false;
        },
        filterBlockLists() {
            return this.blockLists.filter((el) => el.name?.toLowerCase().includes(this.blockSearchValue.toLowerCase()) || el.label?.toLowerCase().includes(this.blockSearchValue.toLowerCase()));
        },
        filteredFieldList() {
            return this.fieldLists
                .filter((el) => el.name?.toLowerCase()
                .includes(this.filterFiledValue.toLowerCase()));
        },
        isUserPermission() {
            let permissions = {
                SHOW_ALL_ACTIONS: this.checkPermission("form.edit"),
                SHOW_FIELD_ADD_ACTIONS: this.checkPermission("field.read"),
                SHOW_BLOCK_ADD_ACTIONS: this.checkPermission("block.read"),
            };
            return permissions;
        },
        addFieldFilters() {
            return [{
                id: "entity_type",
                options: this.entityTypeOptions,
                value: this.fieldTypeFilter,
                // check if any selected type mathches any element's type:
                check: (el) => {
                    if (!this.fieldTypeFilter.length) return true;

                   return el.entity_types.length == this.fieldTypeFilter.length && el.entity_types.every((type) => {
                        return !!this.fieldTypeFilter.find((filter) => filter.id === type.id)
                    })
                },
                reset: (payload) => {
                    this.fieldTypeFilter = payload || [];
                },
                props: {
                    variant: "alt",
                    config: {
                        label: "name",
                        trackBy: "id",
                    },
                },
            }];
        },        
    },
    methods: {
        checkPermission,
        ...mapActions([
            'setFormData'
        ]), 
        handleGapValidationPayload(payload) {
            this.gapValidationPayload = payload;
        },
        async beforeChangeDetails() {
            if (!this.isDirty) {
                return true
            } else {
                const promise = await this.$refs["confirm-popup"].show({
                    title: "Are you sure?",
                    message: "Unsaved data will be lost. Please confirm to continue without saving.",
                });

                if (promise) {
                    await this.getCheckDetails();
                }
                return !!promise;
            }
        },        
        async fetchFieldsList() {
            let payload = {
                tenant_id: this.tenantId,
                req_offset: 0,
                req_limit: 1,
                strict_entity_type_filter: false,
                entity_type: this.checkData.entity_types.map(i => (i.id))
            };
            let url = `/fields/${this.tenantId}/all`;
            let result = await axios.get(url, {
                params: payload,
                paramsSerializer: { indexes: null } 
            });
            return result.data.fields;
        },

        // Fetching Roles
        async fetchAllAvailableRoles() {
            this.fetchingRoles = true;
            this.allRoles = await fetchAllRoles();
            this.fetchingRoles = false;

            // result.data.fields;
        },
        async fetchAvailableReportVisibility() {
            this.allReportsRoles = await fetchReportVisibility();
        },

        async getCheckDetails() {
            let queryId = this.$route.params.id;
            if (queryId) {
                let url = `/tenant-check/${this.tenantId}/${queryId}`;
                let { data } = await axios.get(url);
                try {
                    this.checkData = data.data;
                    this.customCrumbs = [{ name: data?.data?.name ?? "" }];
                    this.checkData.parameters = JSON.parse(this.checkData.parameters);
                    this.checkData = { ...this.checkData };
                    this.setFormData(this.checkData);
                    let sections = formatSections(data.data.sections);
                    this.sectionList = sections;
                    this.isLoading = false;
                } catch (error) {
                    console.log(error, ">>>Error");
                    this.isLoading = false;
                }
                this.isLoading = false;
            }
        },

        // Delete Check

        async handleDeleteCheck(check) {
            await this.$store.dispatch("fetchPermissions");
            if(!this.checkPermission("form.delete")) {
                this.$toast.error("You don't have permission to delete the form.")
                return;
            }
            const promise = await this.$refs["confirm-popup"].show({
                title: "Are you sure?",
                message: "This Form  will be deleted permanently. Please confirm to continue deleting this form.",
            });
            if (promise) {
                let url = `/tenant-check/${this.tenantId}/${check.id}`;
                try {
                    let { data } = await axios.delete(url);
                    this.hideSidePanel();
                    this.$router.push({
                        name: "Form-Admin",
                    });
                    this.$toast.success(data.message, "Check deleted ");
                } catch (error) {
                    this.$toast.error(error?.response?.data?.detail || "Failed to delete check");
                }
            }
            this.$refs["confirm-popup"].close();
        },

        async handleReadAccessMethod(form_id , read_access_only) {
                let url = `/tenant-form/${form_id}/form`;
                try {
                    let payload = {
                        read_access_only: read_access_only
                    };
                    let { data } = await axios.post(url,payload);
                    this.$toast.success(data.message, "form Updated");
                    await this.getCheckDetails();
                } catch (error) {
                    this.$toast.error(error?.response?.data?.detail || "Failed to update form");
                }
        },

        // End Delete Check

        // Add Block

        async addBlock(block) {
            this.currentAddedBlock = null;
            this.currentAddedBlockGapField = null;
            let section = this.activeSection;
            try {
                let url = `/tenant-check/section/${section.id}/block/add`;
                let payload = {
                    block_id: block.id,
                    collect_data_from: this.collect_data_from
                };
                let { data } = await axios.post(url, payload);
                let blockData = {
                    block_details: data || null,
                    block_multi: data.multi || false,
                    entity_type: "block",
                    expanded: true,
                    fields: data.fields,
                    name: data.name,
                    id: data.id,
                    edited: false,
                    max_count: data.max_count,
                    min_count: data.min_count,
                    label: data.label,
                };
                this.sectionList.find((sec) => sec.id === section.id).fields.push(blockData);
                this.currentAddedBlock = blockData;
                this.currentAddedBlockGapField = blockData?.fields.find((el) => el.use_in_gap_validation);
                this.currentAddedBlockGapField = { ...this.currentAddedBlockGapField, overlap_allowed: false, relative: false, start_date_field: null, start_date_label: "", end_date_field: null, end_date_label: "", till_present: false };
                
                // this.sectionList = this.sectionList.map(el => {
                //     if(el.id === section.id){
                //         el.fields.push(blockData)
                //     }
                // })
                await this.getCheckDetails();
                this.$refs["block-modal"].closeModal();
                this.$toast.success(data.message || "Block added to form");
            } catch (error) {
                this.$toast.error(error?.response?.data?.detail || "Failed to add block");
            }
            // // let check_id = this.checkData.id
            // // let url = `/tenant-check/${check_id}/section/${section.id}/block`;
            // let payload = {
            //     fields: [],
            //     id: uuid.v4(),
            //     expanded: true,
            //     entity_type: "block",
            //     created: true,
            //     edited: false,
            //     name: blockName,
            //     block_multi: false,
            //     min_count: 1,
            //     max_count: 1,
            // };
            // this.sectionList.find((sec) => sec.id === section.id).fields.push(payload);
            // this.$toast.success("Block Added");
        },

        // End Add Block

        // Remove Block

        async handleRemoveBlock(section, block) {
            const promise = await this.$refs["confirm-popup"].show({
                title: "Are you sure?",
                message: "This Block  will be deleted permanently. Please confirm to continue deleting this Block.",
            });
            if (promise) {
                let check_id = this.checkData.id;
                let url = `/tenant-check/${check_id}/section/${section.id}/block/${block.id}`;
                if (block.created) {
                    this.sectionList.map((sec) => {
                        if (sec.id === section.id) {
                            let fields = sec.fields.filter((el) => el.id !== block.id);
                            sec = sec.fields = fields;
                        }
                    });
                } else {
                    try {
                        let { data } = await axios.delete(url);
                        this.hideSidePanel();
                        this.sectionList.map((sec) => {
                            if (sec.id === section.id) {
                                let fields = sec.fields.filter((el) => el.id !== block.id);
                                sec = sec.fields = fields;
                            }
                        });
                        await this.getCheckDetails();
                        this.$toast.success(data.message);
                    } catch (error) {
                        this.$toast.error(error?.response?.data?.detail || "Failed to delete block");
                    }
                }
            }
            this.$refs["confirm-popup"].close();
        },

        // End Remove Block

        // section Modal control
        closeSectionModal() {
            this.$refs["show-section-modal"].closeModal();
        },

        showSectionModal() {
            this.$refs["show-section-modal"].showAddSectionModal();
        },

        // End Section Modal control

        // section add field Modal control
        closeFieldAddModal() {
            // this.$refs["section-addfield-modal"].closeModal();
            this.showBlockAddModal = false;
        },
        onChangeFilterResult(event) {
            this.filterFiledValue = event;
        },

        async showFieldAddModal(section, block) {
            const canAddDetails = await this.beforeChangeDetails();
            if (!canAddDetails) return;
            
            this.loadingState.addFields = true;
            this.filterFiledValue = "";
            this.fieldTypeFilter = [];
            // this.$refs["section-addfield-modal"].showAddFieldModal();
            this.showBlockAddModal = true;
            this.fieldToAdd.field = null;
            this.fieldLists = await this.fetchFieldsList();
            await this.fetchAvailableReportVisibility();
            let permisions =
                this.allRoles &&
                this.allRoles?.map((permision) => ({
                    ...permision,
                    title: permision.title,
                    role_read: false,
                    role_write: false,
                    role_visible: false,
                    role_mandatory: false,
                    select_all: false,
                }));
            this.fieldToAdd = {
                section: section,
                block: block ? block : null,
                field: null,
                permisions: permisions,
                all_reports_visibilty: this.allReportsRoles,
                report_visibility: null,
            };
            this.loadingState.addFields = false;
        },

        // End Section add field Modal control

        handleSelectAllPermission(role) {
            let permisions = this.fieldToAdd.permisions;
            if (role.select_all) {
                permisions.map((el) => {
                    if (el.id === role.id) {
                        el.role_read = true;
                        el.role_write = true;
                        el.role_visible = true;
                        el.role_mandatory = true;
                    }
                });
            } else {
                permisions.map((el) => {
                    if (el.id === role.id) {
                        el.role_read = false;
                        el.role_write = false;
                        el.role_visible = false;
                        el.role_mandatory = false;
                    }
                });
            }
            this.fieldToAdd.permisions = permisions;
        },

        handleSelectAllFieldPermission(role) {
            this.activeFieldPanel.field.roles.map((el) => {
                // NOTE: FIX THIS

                if (el.id === role.id) {
                    if (role.select_all) {
                        el.role_read = true;
                        el.role_write = true;
                        el.role_visible = true;
                        el.role_mandatory = true;
                    } else {
                        el.role_read = false;
                        el.role_write = false;
                        el.role_visible = false;
                        el.role_mandatory = false;
                    }
                }
            });
        },

        // Remove section

        async handleRemoveSection(section) {
            const promise = await this.$refs["confirm-popup"].show({
                title: "Are you sure?",
                message: "This section  will be deleted permanently. Please confirm to continue deleting this section.",
            });
            if (promise) {
                let url = `/tenant-check/section`;
                let payload = {
                    check_id: this.checkData.id,
                    section_id: section.id,
                };

                try {
                    let { data } = await axios.delete(url, { data: payload });
                    this.hideSidePanel();
                    this.$toast.success(data.message);
                    let newList = this.sectionList.filter((ele) => ele.id !== section.id);
                    this.sectionList = newList;
                    this.$refs["confirm-popup"].close();
                } catch (error) {
                    this.$toast.error(error?.response?.data?.detail || "Failed to remove section");
                    this.$refs["confirm-popup"].close();
                }
                await this.getCheckDetails();
            }
            this.$refs["confirm-popup"].close();
        },
        async onAddField({ payload, field }) {
            const { roles, report_visibility, use_in_gap_validation ,collect_data_from} = payload;
            const { label, id, is_cascaded } = field;
            const { section, block } = this.fieldToAdd;
            if (!report_visibility) {
                this.$toast.error(`Please select a report visibility option before Adding new field`);
                return;
            }
            const payloadBody = {
                check_name: label,
                field_id: id,
                tenant_check_id: this.checkData.id,
                field_details: {
                    field_global_id: field.id,
                    section_id: section.id,
                    internal_use_only: false,
                    block_id: block ? block.id : null,
                    multi: false,
                    max_field_or_block_count: 1,
                    min_field_or_block_count: 1,
                    is_top_level: false,
                    report_visibility,
                },
                permissions: roles,
                is_cascaded,
                collect_data_from
            };
            if (use_in_gap_validation) {
                const { history, valid_gap } = payload;
                const gapValid = {
                    history: history || history == 0 ? history : 12,
                    use_in_gap_validation: true,
                    valid_gap: valid_gap || valid_gap == 0 ? valid_gap : 30,
                };
                payloadBody.field_details = { ...payloadBody.field_details, ...gapValid };
            }
            let url = `/tenant-check/section/${section.id}/field/add`;
            try {
                let { data } = await axios.post(url, payloadBody);
                if (data.section_field_id) {
                    this.sectionList.map((sec) => {
                        if (sec.id === section.id) {
                            if (block) {
                                sec.fields.map((blockData) => {
                                    if (blockData.id === block.id) {
                                        // NOTE: FIX THIS
                                        blockData.fields.push({
                                            ...payloadBody,
                                            ...payloadBody.field_details,
                                            type: field.type,
                                            report_visibility,
                                            block_id: block.id,
                                            entity_type: "field",
                                            id: data.section_field_id,
                                            label: field.label,
                                            name: field.name,
                                            placeholder: field.placeholder,
                                            roles: roles,
                                            ui_label: field.ui_label,
                                            is_custom: field.is_custom,
                                            use_in_case_creation: false,
                                            is_restricted: field.is_restricted,
                                        });
                                    }
                                });
                            } else {
                                // NOTE: FIX THIS
                                sec.fields.push({
                                    ...payloadBody,
                                    ...payloadBody.field_details,
                                    entity_type: "field",
                                    id: data.section_field_id,
                                    label: field.label,
                                    name: field.name,
                                    type: field.type,
                                    placeholder: field.placeholder,
                                    report_visibility,
                                    roles: roles,
                                    ui_label: field.ui_label,
                                    is_custom: field.is_custom,
                                    use_in_case_creation: false,
                                    is_restricted: field.is_restricted,
                                });
                            }
                        }
                    });
                    await this.getCheckDetails();
                    this.$toast.success("New field has been added to the form.");
                }
            } catch (error) {
                this.$toast.error(error?.response?.data?.detail || "Error while adding field to sections");
            }
        },
        // End Remove section

        // handle Add Field to Sections
        async addFieldToSection({ payload: paramPayload, field: paramfield }) {
            if (!paramPayload.report_visibility) {
                this.$toast.error(`Please select a report visibility option before Adding new field`);
                return;
            }
            let { block, section, field, permisions, report_visibility } = paramfield;
            let new_permisions = [];

            new_permisions = permisions?.map((permision) => {
                const payload_permision = {
                    role_id: permision.id,
                    role_read: permision.role_read,
                    role_write: permision.role_write,
                    role_visible: permision.role_visible,
                    role_mandatory: permision.role_mandatory,
                };
                return payload_permision;
            });

            let payload = {
                check_name: field.label,
                field_id: field.id,
                tenant_check_id: this.checkData.id,
                collect_data_from :"Existing Case Data",
                field_details: {
                    field_global_id: field.id,
                    section_id: section.id,
                    internal_use_only: false,
                    block_id: block ? block.id : null,
                    multi: false,
                    max_field_or_block_count: 1,
                    min_field_or_block_count: 1,
                    is_top_level: false,
                    report_visibility,
                },
                permissions: new_permisions,
                is_cascaded: field.is_cascaded,
            };
            if (this.isGapValidationField) {
                const { history, valid_gap } = this.gapValidationPayload;
                const gapValid = {
                    history: history || history == 0 ? history : 12,
                    use_in_gap_validation: true,
                    valid_gap: valid_gap || valid_gap == 0 ? valid_gap : 30,
                };
                payload.field_details = { ...payload.field_details, ...gapValid };
            }
            if (block && block.created) {
                this.addFieldToNewBlock(block, section, field, payload, permisions);
            } else {
                let url = `/tenant-check/section/${section.id}/field/add`;
                try {
                    let { data } = await axios.post(url, payload);
                    if (data.section_field_id) {
                        this.sectionList.map((sec) => {
                            if (sec.id === section.id) {
                                if (block) {
                                    sec.fields.map((blockData) => {
                                        if (blockData.id === block.id) {
                                            // NOTE: FIX THIS
                                            blockData.fields.push({
                                                ...payload,
                                                ...payload.field_details,
                                                type: field.type,
                                                report_visibility,
                                                block_id: block.id,
                                                entity_type: "field",
                                                id: data.section_field_id,
                                                label: field.label,
                                                name: field.name,
                                                placeholder: field.placeholder,
                                                roles: permisions.map((per) => ({ ...per, role_id: per.id })),
                                                ui_label: field.ui_label,
                                                is_custom: field.is_custom,
                                                use_in_case_creation: false,
                                            });
                                        }
                                    });
                                } else {
                                    // NOTE: FIX THIS
                                    sec.fields.push({
                                        ...payload,
                                        ...payload.field_details,
                                        entity_type: "field",
                                        id: data.section_field_id,
                                        label: field.label,
                                        name: field.name,
                                        type: field.type,
                                        placeholder: field.placeholder,
                                        report_visibility,
                                        roles: permisions.map((per) => ({ ...per, role_id: per.id })),
                                        ui_label: field.ui_label,
                                        is_custom: field.is_custom,
                                        use_in_case_creation: false,
                                    });
                                }
                            }
                        });
                        await this.getCheckDetails()
                        this.$toast.success("New field has been added to the form.");
                    }
                    this.closeFieldAddModal();
                } catch (error) {
                    this.$toast.error(error?.response?.data?.detail || "Error while adding field to sections");
                }
            }
        },
        hideSidePanel() {
            this.showSidePanel = false;
            this.activeFieldPanel = null;
        },
        // Add Field to new added Block
        addFieldToNewBlock(block, section, field, payload, permisions) {
            let fieldData = {
                field_id: payload.field_id,
                internal_use_only: false,
                max_field_or_block_count: payload.field_details.max_field_or_block_count,
                min_field_or_block_count: payload.field_details.min_field_or_block_count,
                is_top_level: payload.field_details.is_top_level,
                permissions: payload.permissions,
                report_visibility: payload.field_details.report_visibility,
                is_cascaded: payload.is_cascaded,
            };

            // If a gap validation field is being added to block
            // it needs to have an additional parameter.
            if (this.isGapValidationField) {
                // fieldData.history = this.gapValidationPayload.history;
                // fieldData.valid_gap = this.gapValidationPayload.valid_gap;
                // fieldData.use_in_gap_validation = true;
                const { history, valid_gap } = this.gapValidationPayload;
                const gapValid = {
                    history: history || history == 0 ? history : 12,
                    use_in_gap_validation: true,
                    valid_gap: valid_gap || valid_gap == 0 ? valid_gap : 30,
                };
                fieldData = { ...fieldData, ...gapValid };
            }

            this.sectionList.map((sec) => {
                if (sec.id === section.id) {
                    sec.fields.map((fie) => {
                        if (fie.id === block.id) {
                            fie.fields.push({
                                ...fieldData,
                                created_with_block: true,
                                block_id: block.id,
                                entity_type: "field",
                                id: uuid.v4(),
                                label: field.label,
                                name: field.name,
                                placeholder: field.placeholder,
                                roles: permisions.map((per) => ({ ...per, role_id: per.id })),
                                use_in_case_creation: false,
                            });
                        }
                    });
                }
            });
        },

        // End New block Field add

        // Save Block with Field

        async saveBlockFields(section, element) {
            let check_id = this.checkData.id;
            let url = `/tenant-check/${check_id}/section/${section.id}/block`;
            let payload = {
                tenant_id: this.tenantId,
                block_name: element.name,
                block_multi: element.block_multi,
                field_list: [],
                max_count: parseInt(element.max_count),
                min_count: parseInt(element.min_count),
            };
            this.hideSidePanel();
            element.fields.forEach((ele) => {
                payload.field_list.push(ele);
            });

            //NOTE(deependar)
            // element.fields.map(ele => payload.field_list.push(
            //     {
            //         field_id: ele.field_id,
            //         internal_use_only: ele.internal_use_only,
            //         max_field_or_block_count: ele.max_field_or_block_count,
            //         min_field_or_block_count: ele.min_field_or_block_count,
            //         is_top_level: ele.is_top_level,
            //         permissions: ele.permissions,
            //         report_visibility: ele.report_visibility
            //         }
            //     ))
            try {
                let { data } = await axios.post(url, payload);
                element.fields = data.fields;
                element.created = false;
                element.id = data.block_id;
                this.$toast.success(data.message);
            } catch (error) {
                this.$toast.error(error?.response?.data?.detail || "Failed to create block");
            }
        },
        async updateSectionFields(section) {
            // TODO connect to API
            await console.log("save section fields", section);
        },

        // End save Block with fields

        // Update block

        async handleUpdateBlock(section, block) {
            let check_id = this.checkData.id;
            let url = `/tenant-check/${check_id}/section/${section.id}/block/${block.id}`;
            let payload = {
                tenant_id: this.tenantId,
                name: block.name,
                multi: block.block_multi,
                block_title: block.block_details.block_title,
                min_count: block.min_count,
                label:block.label,
                max_count: block.max_count,
            };
            if (block.fields) payload.fields = block.fields;
            try {
                let { data } = await axios.put(url, payload);
                block.edited = false;
                this.$toast.success(data.message);
            } catch (error) {
                this.$toast.error(error?.response?.data?.detail || "Failed to update block details");
            }
        },

        // end update Block

        handleCollapseSection(section) {
            this.sectionList.filter((ele) => {
                if (ele.id === section.id) {
                    ele.expanded = !ele.expanded;
                }
            });
        },

        // End collapse Block

        async addNewSection(sectionName) {
            if (!sectionName) return this.$toast.error("Section Name required");
            let url = `/tenant-check/${this.checkData.id}/section`;
            let payload = {
                name: sectionName,
                section_fields: [],
            };
            try {
                let { data } = await axios.post(url, payload);
                let newSection = {
                    id: data.section_id,
                    name: sectionName,
                    expanded: true,
                    blocks: [],
                    fields: [],
                };
                this.sectionList.push(newSection);
                this.$toast.success(data.message);
            } catch (error) {
                this.$toast.error(error?.response?.data?.detail || "Failed to add new section");
            }
            this.closeSectionModal();
        },

        // handle Delete Field form section and Block

        async handleDeleteField(field, section) {
            if(typeof field == 'object' && !section) {
                section = field?.section
                field = field?.field
            }
            const promise = await this.$refs["confirm-popup"].show({
                title: "Are you sure?",
                message: "This field  will be deleted permanently. Please confirm to continue deleting this field.",
            });

            if (promise) {
                let url = `/tenant-check/field`;
                let payload = {
                    check_id: this.checkData.id,
                    section_field_id: field.id,
                    tenant_id: this.tenantId,
                };
                if (field.block_id && field.created_with_block) {
                    this.sectionList.map((sec) => {
                        if (sec.id === section.id) {
                            sec.fields.map((block) => {
                                if (block.id === field.block_id) {
                                    return (block.fields = block.fields.filter((el) => el.id !== field.id));
                                }
                            });
                        }
                    });
                } else {
                    try {
                        let { data } = await axios.delete(url, { data: payload });
                        this.hideSidePanel();
                        if (field.block_id) {
                            this.sectionList.map((sec) => {
                                if (sec.id === section.id) {
                                    sec.fields.map((block) => {
                                        if (block.id === field.block_id) {
                                            return (block.fields = block.fields.filter((el) => el.id !== field.id));
                                        }
                                    });
                                }
                            });
                        } else {
                            this.sectionList.map((sec) => {
                                if (sec.id === section.id) {
                                    return (sec.fields = sec.fields.filter((el) => el.id !== field.id));
                                }
                            });
                        }
                        await this.getCheckDetails();
                        this.$toast.success(data.message);
                    } catch (error) {
                        this.$toast.error(error?.response?.data?.detail || "Failed to delete field");
                    }
                }
            }
            this.$refs["confirm-popup"].close();
            this.handleClosePanel();
        },

        // End Delete Field from section and block

        // update Section Label
        async updateSectionLabel(sectionData) {
            if (this.oldSectionName !== sectionData.name) {
                const url = `/tenant-check/${this.checkData.id}/section/rename`;
                let payload = {
                    section_id: sectionData.id,
                    name: sectionData.name,
                };
                try {
                    const { data } = await axios.post(url, payload);
                    this.$toast.success(data.message);
                } catch (error) {
                    this.$toast.error(error?.response?.data?.detail || "Failed to rename section name!");
                }
            }
        },

        // Update field Name

        async updateFieldLabel(sectionData, checkData, silent = false) {
            checkData = checkData.element || checkData || sectionData.element || sectionData.field
            sectionData = sectionData.section || sectionData
            if (!checkData) {
                return
            }
            this.handleControlGlobalLoader(true, 'Updating Field attributes...')
            if (this.oldFieldName !== checkData.label) {
                const url = `/tenant-check/${this.checkData.id}/section/${sectionData.id}/field`;
                let payload = {
                    section_field_id: checkData.id,
                    label: checkData.label,
                    permissions: checkData.roles,
                    report_visibility: checkData.report_visibility,
                    history: checkData.history,
                    valid_gap: checkData.valid_gap,
                    use_in_gap_validation: checkData.use_in_gap_validation,
                };
                try {
                    const { data } = await axios.put(url, payload);
                    if (checkData.use_in_gap_validation) {
                        const sectionList = cloneDeep(this.sectionList);
                        sectionList.forEach((section, ind1) => {
                            if (section.id === checkData.section_id) {
                                section.fields.forEach((field, ind2) => {
                                    if (field.id === checkData.block_id) {
                                        field.fields.forEach((_, ind3) => {
                                            if (_.id === checkData.id) {
                                                sectionList[ind1].fields[ind2].fields[ind3] = {
                                                    ..._,
                                                    history: checkData.history,
                                                    valid_gap: checkData.valid_gap,
                                                };
                                            }
                                        });
                                    } else {
                                        if (checkData.id === field.id) {
                                            sectionList[ind1].fields[ind2] = {
                                                ...field,
                                                history: checkData.history,
                                                valid_gap: checkData.valid_gap,
                                            };
                                        }
                                    }
                                });
                            }
                        });
                        this.sectionList = sectionList;
                        this.$refs.gapValidationModal.closeModal();
                    }
                    // }
                    if (!silent) this.$toast.success(data.message);
                } catch (error) {
                    this.oldFieldName = "";
                    this.handleControlGlobalLoader(false)
                    this.$toast.error(error?.response?.data?.detail || "Failed to rename field name!");
                    throw error;
                }
            }
            this.handleControlGlobalLoader(false)
        },

        updateActiveTab(event) {
            let relative_status = event === "relative" ? true : false;
            this.currentAddedBlockGapField = { ...this.currentAddedBlockGapField, relative: relative_status };
        },
        
        updateOption({ option, key }) {
            this.currentAddedBlockGapField = { ...this.currentAddedBlockGapField, [key]: option };
        },
        updateLabel({input, key}){
            this.currentAddedBlockGapField = { ...this.currentAddedBlockGapField, [key]: input };
        },

        updateTillPreset({input, startDateLabel}) {
            if (input === "till_present") {
                this.currentAddedBlockGapField = { ...this.currentAddedBlockGapField, till_present: true, end_date_field:null, end_date_label:"",start_date_label: startDateLabel};
            } else {
                this.currentAddedBlockGapField = { ...this.currentAddedBlockGapField, till_present: false };
            }
        },

        async handleUpdateBlockFieldGapTimeLine(copyCurrentBlockField) {
            let { id, roles, history, valid_gap, block_id, label, report_visibility, overlap_allowed, relative, start_date_field, start_date_label, end_date_field, end_date_label, till_present } = copyCurrentBlockField
            let payload = {
                section_field_id: id,
                permissions: roles,
                label,
                report_visibility,
                overlap_allowed: overlap_allowed || false,
                valid_gap,
                relative: relative || false,
            };
            if (relative) {
                if (till_present) {
                    payload = {
                        ...payload,
                        start_date_field: (start_date_field && start_date_field.id) || null,
                        start_date_label,
                        end_date_field: null,
                        end_date_label: null,
                        till_present: till_present || false,
                        history: null,
                    };
                } else {
                    payload = {
                        ...payload,
                        start_date_field: (start_date_field && start_date_field.id) || null,
                        start_date_label,
                        end_date_field: (end_date_field && end_date_field.id) || null,
                        end_date_label,
                        till_present: till_present || false,
                        history: null,
                    };
                }
            } else {
                payload = {
                    ...payload,
                    history,
                    start_date_field:  null,
                    start_date_label: null,
                    end_date_field: null,
                    end_date_label: null,
                    till_present: false,
                };
            }
            try {
                const url = `/tenant-check/${this.checkData.id}/section/${this.activeGapValidation.section.id}/field`;
                const { data } = await axios.put(url, payload);
                this.$toast.success(data.message);
                const sectionList = cloneDeep(this.sectionList);
                sectionList.forEach((section, ind1) => {
                    if (section.id === this.activeGapValidation.section.id) {
                        section.fields.forEach((field, ind2) => {
                            if (field.id === block_id) {
                                field.fields.forEach((_, ind3) => {
                                    if (_.id === id) {
                                        sectionList[ind1].fields[ind2].fields[ind3] = {
                                            ..._,
                                            ...payload,
                                        };
                                    }
                                });
                            }
                        });
                    }
                });
                this.sectionList = sectionList;
                this.closeGapTimeLineModal();
            } catch (error) {
                console.log(error, "error");
                this.$toast.error(error?.response?.data?.detail || "Failed to update field!");
            }
        },


        closeGapTimeLineModal() {
            this.$modal.hide("gap-time-line-modal");
        },

        fieldNameClick(checkData) {
            this.oldFieldName = checkData.label;
        },
        // Field Reorder
        async handleFieldChange(e) {

            const { event: _e, section: _section } = e;
            
            const _event = _e.added || _e.moved || _e.removed;

            if (_event) {
                this.handleControlGlobalLoader(true, 'Reordering...')
                const field_lists = [];
    
                this.sectionList.forEach((section) => {
                    const _fieldList = section.fields;

                    if (_e.added && _section.id == section.id) {
                        _e.added.element.form_section_id = _section.id;

                        if (_e.added.element.fields) {
                            _e.added.element.fields.forEach(i => {
                                i.form_section_id = _section.id;
                            });
                        }

                        _fieldList.splice(_e.added.newIndex, 0, _e.added.element);

                    } else {

                        const elementIndex = section.fields.findIndex(x=> x.id === _event?.element?.id);
    
                        if (elementIndex != -1) {
                            if (_e.moved) {
                                let removed = _fieldList.splice(_e.moved.oldIndex, 1);
                                _fieldList.splice(_e.moved.newIndex, 0, ...removed);
                            } else if (_e.removed && _section.id == section.id) {
                                _fieldList.splice(_e.removed.oldIndex, 1);
                            }
                        }
                    }

                    _fieldList.forEach((field) => {
                        const _fields = field.fields || [field];
                        _fields.forEach((item) =>  {
                            field_lists.push({ section_field_id: item.id, section_id: item.form_section_id || item.section_id, order: field_lists.length + 1 })
                        });
                    });
                });

                /*
                    'added' and 'removed' events are triggered in a sequence.
                    that's why after 'added' event only array modification is performed.
                    api request comes after 'removed' event
                */
                if (_e.added) return;
                
                const url = `/tenant-check/${this.checkData.id}/fields/reorder`;
                let payload = {
                    tenant_id: this.tenantId,
                    field_list: field_lists,
                };
                try {
                    let {data} = await axios.post(url, payload);
                    this.$toast.success(_event.element?.entity_type === 'block' ?  'Block reordered' : 'Field reordered' || data.message);
                } catch (error) {
                    this.$toast.error(error?.response?.data?.detail || "Failed to reorder!");
                }
                this.handleControlGlobalLoader(false)
            }
            
        },

        // reorder section
        async hanldeSectionReorder(e) {
            if (e.moved) {
                const section_list = [];
                const removed = this.sectionList.splice(e.moved.oldIndex, 1);
                this.sectionList.splice(e.moved.newIndex, 0, ...removed);
                this.sectionList.forEach((i, ind) => {
                    i.order = ind;
                    section_list.push({ section_id: i.id, order: ind + 1 })
                })

                const url = `/tenant-check/${this.checkData.id}/section/reorder`;
                let payload = {
                    tenant_id: this.tenantId,
                    section_list: section_list,
                };
                try {
                    const { data } = await axios.post(url, payload);
                    this.$toast.success(data.message);
                } catch (error) {
                    this.$toast.error(error?.response?.data?.detail || "Failed to reorder section!");
                }
            }
        },

        // end reorder section
        handleAddFieldChange(e) {
            console.log(e, "add field Event");
        },

        onShowPanel(element, section) {
            if (element.is_cascaded) return;
            this.handleShowPanel(element, section);
        },

        async handleShowPanel(element, section) {
            if (!element.fields) {
                element.roles = element?.roles.map((role) => ({ ...role, select_all: role.role_mandatory && role.role_read && role.role_visible && role.role_write }));
                this.showSidePanel = true;
                this.activeFieldPanel = {
                    field: element,
                    section: section,
                    is_cascaded: element.is_cascaded,
                };
                if (element.is_cascaded) {
                    this.loadingState.getDependent = true;
                    try {
                        const { data } = await axios.get(`/tenant-check/section/${section.id}/field/${element.id}/dependents`);
                        this.dependentsFields = data.dependents;
                    } catch (error) {
                        console.log("error :>> ", error);
                    }
                    this.loadingState.getDependent = false;
                }
            }
        },
        showFieldSettingsModal(element = null, section) {
            if (!element) {
                this.activeFieldSettings = {
                    field: null,
                    section: null,
                };
                return;
            }
            element.roles = element?.roles.map((role) => ({ ...role, select_all: role.role_mandatory && role.role_read && role.role_visible && role.role_write }));
            this.activeFieldSettings = {
                field: element,
                section: section,
                is_cascaded: element.is_cascaded,
            };
            this.$refs.fieldSettingsModal.showModal();
        },
        showGapValidationModal(element = null, section) {
            if (!element) {
                this.activeGapValidation = {
                    field: null,
                    section: null,
                };
                return;
            }
            this.activeGapValidation = {
                field: element,
                section,
            };
            this.currentAddedBlockGapField = element;
            this.currentAddedBlock = element;
            this.showGapTimeLineModal();
        },

        async showGapTimeLineModal() {
            await this.getDateTypeFields();
            let { start_date_field, end_date_field } = this.currentAddedBlockGapField;
            if (start_date_field || end_date_field) {
                this.currentAddedBlockGapField = { ...this.currentAddedBlockGapField, start_date_field: this.dateTypeFields.find((el) => el.id === start_date_field), end_date_field: this.dateTypeFields.find((el) => el.id === end_date_field) };
            }
            this.$nextTick(() => {
                this.isBlockGapValidation && this.$modal.show("gap-time-line-modal");
                // this.isBlockGapValidation && this.dateTypeFields && this.dateTypeFields.length > 0 && this.$modal.show('gap-time-line-modal');
            });
        },

        async getDateTypeFields() {
            this.loadingStates.dateType = true;
            // let token = VueCookies.get("token");
            let token = VueCookies.get("tenant_token") || VueCookies.get("client_token");
            const { data } = await axios.get(`tenant-check/${this.tenantId}/${this.$route.params.id}/fields/dates`,
            {headers: {
                'Authorization':`Bearer ${token}`
            }});
            this.dateTypeFields = data.date;
            this.loadingStates.dateType = false;
        },
        handleResetGapTimelineFields() {
            this.currentAddedBlockGapField = {
                ...this.currentAddedBlockGapField,
                relative: false,
                valid_gap: null,
                history: null,
                overlap_allowed: false,
                start_date_field: null,
                start_date_label: "",
                end_date_field: null,
                end_date_label: "",
                till_present: false,
            };
        },
        handleClosePanel() {
            this.showSidePanel = false;
            this.activeFieldPanel = {
                field: null,
                section: null,
            };
        },

        // Handle Save Check -----------------

        async handleSaveCheck() {
            let checkInfo = this.checkData;
            let url = `/tenant-check/${this.tenantId}/${checkInfo.id}`;
            let playload = {
                name: checkInfo.name,
                description: checkInfo.description,
                sla: parseInt(checkInfo.sla),
                parameters: checkInfo.parameters && checkInfo.parameters.parameters ? JSON.stringify(checkInfo.parameters.parameters) : "[]",
                check_type: "form",
                entity_types: checkInfo.entity_types.map((el) => ({ entity_type_id: el.id })),
            };
            try {
                let { data } = await axios.put(url, playload);
                await this.getCheckDetails();
                this.$toast.success(data.message);
            } catch (error) {
                this.$toast.error(error?.response?.data?.detail || "Failed to update check");
            }
        },

        //  Save Check End -----------------

        // mandatory permission select karne pe write/read/visible selected hona chahiye by default
        // write permission select karne pe read & visibel select hone chahiye by default
        // read karne be visible select hona chahiye by default

        PermissionChange(role) {
            if (role.role_mandatory) {
                role.role_read = true;
                role.role_write = true;
                role.role_visible = true;
                role.select_all = true;
            } else if (role.role_write) {
                role.role_read = true;
                role.role_visible = true;
                role.select_all = false;
            } else if (role.role_read) {
                role.role_visible = true;
                role.select_all = false;
            }
        },
        changeCollectDataFrom(payload) {
            // TODO WLPRM-3018, point 3 was postponed
            console.log('changeCollectDataFrom', payload)
        },

        async showBlockModal(section) {
            const canAddDetails = await this.beforeChangeDetails();
            if (!canAddDetails) return;
            this.activeSection = section;
            this.blockSearchValue = "";
            this.fieldTypeFilter = [];
            this.$refs["block-modal"].showBlockModal();
            await this.fetchBlockLists();
        },
        async fetchBlockLists() {
            this.loadingLists = true;
                let payload = {
                strict_entity_type_filter: false,
                entity_type: this.checkData.entity_types.map(i => (i.id))
            };
            try {
                let url = `/blocks`;
                let { data } = await axios.get(url, {
                    params: payload,
                    paramsSerializer: { indexes: null } 
                });
                this.blockLists = data.data || [];
            } catch (error) {
                console.log(error, ">>>>>error");
            }
            this.loadingLists = false;
        },

        onChangehandleFilterResult(searchValue) {
            this.blockSearchValue = searchValue;
        },

        // Update Dependendta Field label
        async updateDependentsFieldLabel(field) {
            const url = `/tenant-check/${this.checkData.id}/section/${field.section_id}/field`;
            let payload = {
                section_field_id: field.id,
                label: field.name,
                permissions: field.permissions,
                report_visibility: field.report_visibility,
            };
            try {
                const { data } = await axios.put(url, payload);
                this.$toast.success(data.message);
            } catch (error) {
                this.$toast.error(error?.response?.data?.detail || "Failed to rename field name!");
            }
        },
        async getDependents(field_id, option_value) {
            const result = await axios.get(`tenant-check/field/${field_id}/options/${option_value}/dependents`);
            return result;
        },
        async getOptions(field_id) {
            const result = await axios.get(`tenant-check/field/${field_id}/options`);
            return result;
        },
        async changeCaseCreation(payload) {
            try {
                const result = await axios.patch(`tenant-check/caseform/${payload.id}`, {
                    state: payload.use_in_case_creation || false,
                });
                if (result) {
                    this.$toast.success(payload.use_in_case_creation ? `Using in case creation` : `Removed from case creation`);
                }
            } catch (error) {
                this.$toast.error(error.response.data.detail || this.$t("general.default_error"));
            }
        },
        async changeblockVisibile(payload) {
            try {
                const result = await axios.patch(`tenant-check/block_visibility/${payload.id}`, {
                    block_visibility: payload.block_visibility || false,
                });
                if (result) {
                    this.$toast.success(payload.block_visibility ? `Using in block visibility` : `Removed from block visibility`);
                }
            } catch (error) {
                this.$toast.error(error.response.data.detail || this.$t("general.default_error"));
            }
        },
        handleControlGlobalLoader(status, message){
            this.isGlobalLoader = {
                status,
                message:message || 'Loading...'
            }
        },
        handleCollectData(val){
            this.collect_data_from = val;
        }
    },
    // async beforeRouteEnter (to, from, next) {
    //     console.log("to", to);
    //     next((vm) => {
    //         if(from.name === null && to.name === "form admin details") {
    //             vm.directURl = true;
    //         } else {
    //              vm.directURl = false;
    //         }
    //     });
    //   },
};
</script>

<!-- <script>
import axios from "@/axios";
import { formatSections } from "@/modules/field-editor/services.js";
// fetchAllRoles, fetchReportVisibility

const SubHeader = () => import("@/components/SubHeader");
const Loader = () => import("@shared/loader");
const SectionLists = () => import("@/pages/check-admin/check-dragable-section/components/sectionLists.vue");
// import sectionLists from "./components/sectionLists.vue";

export default {
    name: "Form-Draggable-Section",
    data() {
        return {
            loadingStates: {
                tenant: false,
            },
            showSidePanel: false,
            sectionList: [],
        };
    },
    components: {
        SubHeader,
        Loader,
        SectionLists,
    },
    methods: {
        showSectionModal() {
            // this.$refs["show-section-modal"].showAddSectionModal();
        },
        async getCheckDetails() {
            this.loadingStates.tenant = true;
            let queryId = this.$route.params.id;
            if (queryId) {
                this.loadingStates.tenant = true;
                let url = `/tenant-check/${this.tenantId}/${queryId}`;
                let { data } = await axios.get(url);
                try {
                    this.checkData = data.data;
                    this.checkData.parameters = JSON.parse(this.checkData.parameters);
                    this.checkData = { ...this.checkData, expanded: true };
                    let sections = formatSections(data.data.sections);
                    this.sectionList = sections;
                    this.loadingStates.tenant = false;
                } catch (error) {
                    this.loadingStates.tenant = false;
                }
                this.loadingStates.tenant = false;
            }
        },
        async addBlock(block) {
            let section = this.activeSection;
            try {
                let url = `/tenant-check/section/${section.id}/block/add`;
                let payload = {
                    block_id: block.id,
                };
                let { data } = await axios.post(url, payload);
                let blockData = {
                    block_details: data,
                    block_multi: data.multi,
                    entity_type: "block",
                    expanded: true,
                    fields: data.fields,
                    name: data.name,
                    id: data.id,
                };
                this.sectionList = this.sectionList.map((el) => {
                    if (el.id === section.id) {
                        el.fields.push(blockData);
                    }
                });
                this.$toast.success(data.message || "Block created");
            } catch (error) {
                this.$toast.error(error?.response?.data?.detail || "Failed to created block");
            }
        },
    },
};
</script> -->

<style lang="scss" scoped></style>
